import { parse, format } from 'date-fns';
import PropTypes from 'prop-types';
import React from 'react';
import Svg from 'rp-react-svg-icon';

const generateLinkDescription = (body) => {
    if (Array.isArray(body)) {
        return body.join(' ').substr(0, 75);
    }

    return body.substr(0, 75);
};

/**
 * Presentational component for stories result list
 */
export default function StoriesList({ items }) {
    return (
        <ul className="search-resultList">
            {items.map(({ id, url, title, published_at, body }) => (
                <li
                    key={id}
                    className="search-resultList__item"
                >
                    <a
                        className="search-resultList__link"
                        href={url}
                    >
                        <span className="search-resultList__linkHeadline ui-link ui-link_table">
                            {title}
                            <Svg
                                iconName="right"
                                size="XSmall"
                            />
                        </span>
                        <span className="search-resultList__linkDate">
                            {format(parse(published_at), 'MMM DD YYYY')}
                        </span>
                        <span className="search-resultList__linkDescription">
                            {`${generateLinkDescription(body)}...`}
                        </span>
                    </a>
                </li>
            ))}
        </ul>
    );
}

StoriesList.propTypes = {
    /**
     * Story result items
     */
    items: PropTypes.arrayOf(PropTypes.shape({
        /**
         * Target page URL
         */
        url: PropTypes.string.isRequired,
        /**
         * Story title
         */
        title: PropTypes.string.isRequired,
        /**
         * Story publish date
         */
        published_at: PropTypes.string.isRequired,
        /**
         * Story text
         */
        body: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.arrayOf(PropTypes.string),
        ]).isRequired,
    })).isRequired,
};



// WEBPACK FOOTER //
// ./src/js/Stories/components/StoriesList.jsx